import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { COUNTRY_CODES } from '@/constants/country-codes';
import { CURRENCY_CODE } from '@/core/currency/constants/currency';
import Constants from '../constants';
import { CurrencyInfo } from '../interfaces';

@Component({
    data() {
        return {
            currency: null
        };
    }
})
export default class CurrencyMixin extends Vue {
    currency: CurrencyInfo;

    get currencySymbol() {
        return this.currency?.symbol || '';
    }

    get currencyLocale() {
        return this.currency?.format || '';
    }

    getExchangeRate(currencyCode: string, countryCode?: string) {
        if (
            countryCode === COUNTRY_CODES.Bulgarian &&
            currencyCode === CURRENCY_CODE.Euro
        ) {
            return Constants.BULGARIAN_EXCHANGE_RATE;
        }

        return Constants.EXCHANGE_RATES[currencyCode];
    }

    setCurrency(countryCode: string) {
        const currencyCode = countryCode && Constants.COUNTRY_CURRENCY[countryCode]
            ? Constants.COUNTRY_CURRENCY[countryCode]
            : Constants.DEFAULT_CURRENCY;

        this.currency = this.getCurrencyByCode(currencyCode);
    }

    getCurrencyByCode(currencyCode: string) {
        return Constants.CURRENCY[currencyCode];
    }
}
